/**
 * Page-level style scopes.
 *
 * Shared components (rater-x listings, inputs) render on more than one page.
 * A page that wants its own sizing puts one of these classes on its root, and
 * a shared style keeps its default and adds the page's values under
 * `.<class> &` — so the other pages render exactly as before.
 */

/** The Prime X underwriter view's root. */
export const UW_VIEW_CLASS = 'uw-view';

/** A JSS / sx selector for "inside the underwriter view". */
export const UW_VIEW_SCOPE = `.${UW_VIEW_CLASS} &`;
